import { axiosInstancePrivateServicesFluxiUrl } from "@/services/instance";

export interface EmailExistsResponse {
  email: string;
  exists: boolean;
}

export const emailExistsService = {
  async getByEmail(email: string): Promise<EmailExistsResponse> {
    const safeEmail = encodeURIComponent(email.trim());
    const response = await axiosInstancePrivateServicesFluxiUrl.get(
      `/api/ms/ecommerce-service/user/email-exists/${safeEmail}`
    );
    return response.data as EmailExistsResponse;
  },
};


